export default __webpack_public_path__ + "static/media/Stamin.e95a03cc.png";